import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-42',
  templateUrl: './cards7-examples-42.component.html'
})
export class Cards7Examples42Component {}
